var map = {
	"./audio-login.wav": 6268,
	"./bgm-1-1.wav": 3320,
	"./bgm-1-2.wav": 9375,
	"./bgm-1-3.wav": 4054,
	"./bgm-1.mp3": 4706,
	"./bgm-2.mp3": 1333,
	"./bgm-3.mp3": 4704,
	"./bgm-4.mp3": 6819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3595;